import axios from '@/plugins/axios'

export const collectionService = {
  getCollectionData(page = 1, limit = 1000, filters = {}) {
    return axios.get('/collection', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  getLoanCollection(subCase, page = 1, limit = 1000, filters = {}) {
    return axios.get('/collection/loan', {
      params: {
        subCase,
        page,
        limit,
        ...filters
      }
    })
  },
  getExtendedUsecases() {
    return axios.get('/orgSetup/extend-usecase')
  },
  getEmiDetails(page = 1, limit = 1000, filters = {}) {
    return axios.get('/collection/emi-details', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  getCaseTasks(page = 1, limit = 1000, filters = {}) {
    return axios.get('/collection/case/tasks', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  getAssetClassificationRules() {
    return axios.get('/orgSetup/asset-classification-provisioning')
  },
  getLedgerGroups() {
    return axios.get('/orgSetup/ledger-groups')
  },
  getAggregatedJournals(params) {
    return axios.get('/orgSetup/journals/aggregated', { params })
  },
  getAggregatedBsJournals(params) {
    return axios.get('/orgSetup/journals/aggregated-bs', { params })
  }
}
